// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.selected {
  --background: var(--selected-background);
}
ion-item ion-label {
  font-size: 18px;
}
ion-item ion-label p {
  margin: 0;
  color: var(--ion-color-medium-shade);
  font-size: 14px;
}
ion-item ion-button {
  --padding-start: 0;
  --padding-end: 0;
}
ion-item ion-button ion-icon {
  color: var(--ion-color-medium-shade);
}
ion-item .level-icon {
  font-size: 20px;
  margin-right: 16px;
}
ion-item .level-icon.level-icon--0 {
  color: var(--blue-status-shade);
}
ion-item .level-icon.level-icon--1 {
  color: var(--green-status-shade);
}
ion-item .level-icon.level-icon--2 {
  color: var(--green-status);
}

:host-context(.vimar) .level-icon.level-icon--0 {
  color: var(--ion-color-primary-shade);
}
:host-context(.vimar) .level-icon.level-icon--1 {
  color: var(--label-color);
}
:host-context(.vimar) .level-icon.level-icon--2 {
  color: var(--grey-status);
}

ion-searchbar {
  padding: 0;
  margin-top: 8px;
}

app-no-content {
  display: block;
  height: 100%;
}
app-no-content ::ng-deep .content {
  width: 100%;
  min-width: 0;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/general-components/popup-environment-tree/popup-environment-tree.component.scss"],"names":[],"mappings":"AACI;EACI,wCAAA;AAAR;AAGI;EACI,eAAA;AADR;AAGQ;EACI,SAAA;EACA,oCAAA;EACA,eAAA;AADZ;AAKI;EACI,kBAAA;EACA,gBAAA;AAHR;AAKQ;EACI,oCAAA;AAHZ;AAOI;EACI,eAAA;EACA,kBAAA;AALR;AAQQ;EACI,+BAAA;AANZ;AASQ;EACI,gCAAA;AAPZ;AAUQ;EACI,0BAAA;AARZ;;AAcI;EACI,qCAAA;AAXR;AAcI;EACI,yBAAA;AAZR;AAeI;EACI,yBAAA;AAbR;;AAiBA;EACI,UAAA;EACA,eAAA;AAdJ;;AAiBA;EACI,cAAA;EACA,YAAA;AAdJ;AAgBI;EACI,WAAA;EACA,YAAA;EACA,YAAA;AAdR","sourcesContent":["ion-item {\n    &.selected {\n        --background: var(--selected-background);\n    }\n\n    ion-label {\n        font-size: 18px;\n\n        p {\n            margin: 0;\n            color: var(--ion-color-medium-shade);\n            font-size: 14px;\n        }\n    }\n\n    ion-button {\n        --padding-start: 0;\n        --padding-end: 0;\n\n        ion-icon {\n            color: var(--ion-color-medium-shade);\n        }\n    }\n\n    .level-icon {\n        font-size: 20px;\n        margin-right: 16px;\n\n        // One color per tree level (max 3 levels)\n        &.level-icon--0 {\n            color: var(--blue-status-shade);\n        }\n\n        &.level-icon--1 {\n            color: var(--green-status-shade);\n        }\n\n        &.level-icon--2 {\n            color: var(--green-status);\n        }\n    }\n}\n\n:host-context(.vimar) .level-icon {\n    &.level-icon--0 {\n        color: var(--ion-color-primary-shade);\n    }\n\n    &.level-icon--1 {\n        color: var(--label-color);\n    }\n\n    &.level-icon--2 {\n        color: var(--grey-status);\n    }\n}\n\nion-searchbar {\n    padding: 0;\n    margin-top: 8px;\n}\n\napp-no-content {\n    display: block;\n    height: 100%;\n\n    ::ng-deep .content {\n        width: 100%;\n        min-width: 0;\n        height: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
